import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ITableDescriptionParams {
  id: string;
  description: string;
}

export class SetTableDescriptionRequest extends Request<ITableDescriptionParams, IResult> {
  constructor(params: ITableDescriptionParams) {
    super('setTableDescription', params);
  }
}
